import { lazy } from 'react';

const ProjectsIIRSA = lazy(() => import('~screens/Dashboard/screens/ProjectsIIRSA'));
const IIRSAProjectDetail = lazy(() => import('~screens/Dashboard/screens/ProjectsIIRSA/screens/ProjectDetail'));
const Error404 = lazy(() => import('~screens/Dashboard/screens/Error404'));

export const ROUTES = {
  HOME: '/',
  PROJECT_DETAIL: '*',
  PROJECTS: '*',
  NOT_FOUND: '*',
  ERROR404: '*',
  IIRSA_PROJECTS: '/projects',
  IIRSA_PROJECTS_CHARTS: '/project-charts',
  IIRSA_PROJECT_DETAIL: '/projects/:id/show',
  ROUTES: '/routes',
  ROUTES_MAP: '/routes/map',
};

export const NOT_SCROLL_IN_REDIRECT = 'notScrollInRedirect';

export const ROUTES_CONFIG = [
  {
    isPublicRoute: true,
    exact: true,
    path: ROUTES.ROUTES_MAP,
    component: ProjectsIIRSA,
    title: 'SEO:searchTitle',
    description: 'SEO:searchDescription'
  },
  {
    isPublicRoute: true,
    exact: true,
    path: ROUTES.IIRSA_PROJECTS,
    component: ProjectsIIRSA,
    title: 'SEO:searchTitle',
    description: 'SEO:searchDescription'
  },
  {
    isPublicRoute: true,
    exact: true,
    path: ROUTES.IIRSA_PROJECTS_CHARTS,
    component: ProjectsIIRSA,
    title: 'SEO:searchTitle',
    description: 'SEO:searchDescription'
  },
  // {
  //   isPublicRoute: true,
  //   exact: true,
  //   path: ROUTES.NOT_FOUND,
  //   component: Error404,
  //   title: 'SEO:notFoundTitle',
  //   description: 'SEO:notFoundDescription'
  // },
  {
    isPublicRoute: true,
    exact: true,
    path: ROUTES.ERROR404,
    component: Error404,
    title: 'SEO:notFoundTitle',
    description: 'SEO:notFoundDescription'
  }
];

export default ROUTES;
